"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

import talentIcon from "@/assets/Icon/talentIcon.svg";
import recruiterIcon from "@/assets/Icon/recruiterIcon.svg";

import { userType } from "@/types/formInfo.interface";

import { Carousel } from "primereact/carousel";

import RecruiterWatingList from "@/components/RecruiterWatingList";
import TalentRegister from "@/components/Auth/Register/TalentRegister";
import RecruiterRegister from "@/components/Auth/Register/RecruiterRegister";
import usePageLoadStatus from "@/hooks/usePageLoadStatus";

const features = [
  {
    id: "3",
    title: "portfolii for recruiters is coming soon!",
    // image: img,
    text: (
      <div className="text-left px-4 flex flex-column gap-3">
        <p>
          Be the Trailblazer: Gain Early Access to High-Achieving Candidate
          Portfolios and Secure Top Talent Ahead of the Competition.
          <br />
          Experience the Future of Talent Acquisition - Join Our Waiting List
          Today!
        </p>
      </div>
    ),
  },
];

const ItemBlock = ({
  title,
  description,
  onClick,
  icon,
  backgroundColor,
}: {
  icon: string;
  title: string;
  description: string;
  backgroundColor?: string;
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className="w-full flex align-items-center justify-content-between cursor-pointer border-round py-5 px-4 transition-all transition-duration-500 hover:shadow-2"
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <div className="w-full">
        <img src={icon} alt="magic icon" width={45} />
        <div className="flex align-items-center justify-content-between w-full">
          <span className="font-bold text-xl lg:text-2xl  mt-3 mb-3 text-bluegray-900 block">
            {title}
          </span>
          <i className="pi pi-angle-right text-2xl"></i>
        </div>
        <div className="text-gray-600">{description}</div>
      </div>
    </div>
  );
};

const Register = () => {
  // const pageIsLoaded = usePageLoadStatus();

  const router = useRouter();
  const [stepSlider, setStepSlider] = useState(0);

  const hasTrialUser = router.query.trial;

  const [userType, setuserType] = useState<userType>(
    router.query.usertype || "talent"
  );

  useEffect(() => {
    if (router.query.usertype === "recruiter" || hasTrialUser) {
      setStepSlider(2);
    }
  }, [router.query.usertype, hasTrialUser]);

  return (
    <div className="flex flex-column align-items-center justify-content-center m-4 lg:my-5 lg:mx-6">
      <div className="surface-ground w-full">
        <div className="flex flex-wrap w-full m-auto">
          <div className="w-full lg:w-5 py-3 lg:px-0 lg:py-4 lg:p-7 bg-blue-50">
            {(stepSlider === 0 ||
              stepSlider === 1 ||
              (stepSlider === 2 && hasTrialUser)) && (
              <div className="">
                <div className="font-medium text-xl my-3 text-blue-900 block text-center">
                  Welcome to portfolii
                </div>
              </div>
            )}
            {stepSlider === 2 && userType === "recruiter" && (
              <div className="">
                <div className="font-medium text-xl my-3 text-blue-900 block text-center">
                  portfolii for recruiters is coming soon!
                </div>
                <div className="text-left px-4 flex flex-column gap-3">
                  <p className="m-0 text-blue-700 line-height-3">
                    Be the Trailblazer: Gain Early Access to High-Achieving
                    Candidate Portfolios and Secure Top Talent Ahead of the
                    Competition.
                    <br />
                    Experience the Future of Talent Acquisition - Join Our
                    Waiting List Today!
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="w-full p-3 lg:px-6 lg:py-5 lg:w-7 surface-card flex flex-column align-items-center gap-5">
            {stepSlider === 0 && (
              <div className="w-full flex flex-column gap-4 lg:px-8">
                <ItemBlock
                  title="I am a talent"
                  description="willing to take my career to the next level"
                  icon={talentIcon.src}
                  backgroundColor="rgba(125, 202, 68, 0.1)"
                  onClick={() => {
                    setStepSlider(1);
                    setuserType("talent");
                  }}
                />
                <ItemBlock
                  title="I am a recruiter"
                  description="looking for high-achieving talents"
                  icon={recruiterIcon.src}
                  backgroundColor="rgba(50, 104, 145, 0.1)"
                  onClick={() => {
                    setStepSlider(2);
                    setuserType("recruiter");
                  }}
                />
              </div>
            )}
            {stepSlider === 1 && userType === "talent" && <TalentRegister />}
            {stepSlider === 2 && userType === "recruiter" && (
              <RecruiterWatingList />
            )}
            {stepSlider === 2 && hasTrialUser && <RecruiterRegister />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
